var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notice-wrap"},[_c('NoticeBar',{attrs:{"left-icon":"volume","background":"var(--bg)","color":"var(--theme)","text":_vm.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }